import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../_services/auth.service';
import { DatePipe } from '@angular/common';
import { AppComponent } from 'src/app/app.component';
import { HomeComponent } from '../home.component';
declare var $;

@Component({
  selector: 'app-page-visited-history',
  templateUrl: './page-visited-history.component.html',
  styleUrls: ['./page-visited-history.component.css'],
})
export class PageVisitedHistoryComponent implements OnInit {
  TotalVisit: any;
  TodayTotalVisit: any;
  HighestVisitedPage: any;
  HighestVisitedBy: any;
  dataTable: any;
  dtOptions: any;
  tableData = [];
  @ViewChild('dataTable', { static: true }) table;

  constructor(
    private authService: AuthService,
    private datepipe: DatePipe,
    private appComponent: AppComponent,
    private homeComponent: HomeComponent
  ) {}

  ngOnInit() {
    this.authService.isAuthenticated();
    this.appComponent.setTitle('Page Visit History');

    this.authService.pageVisit().subscribe(
      () => {},
      (error) => {
        console.log(error);
      }
    );

    this.getPageVisitedHistoryData();
  }

  SetInactive() {
    this.homeComponent.SetInactive();
  }

  getPageVisitedHistoryData() {
    this.authService.getPageVisitedHistoryData().subscribe(
      (data) => {
        this.TotalVisit = data.totalvisit;
        this.HighestVisitedPage = data.highestvisitedpage;
        this.HighestVisitedBy = data.highestvisitedby;
        data.visitedlist.forEach((value, index) => {
          value.index = index + 1;
          value.visitedDate = this.appComponent.UTCToLocalTime(
            value.visitedDate
          );
          value.date = this.datepipe.transform(value.visitedDate, 'yyyy-MM-dd');
        });
        const date = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
        this.TodayTotalVisit = data.visitedlist.filter(
          (x) => x.date === date
        ).length;
        this.tableData = data.visitedlist;
        this.dtOptions = {
          data: this.tableData,
          columns: [
            { title: '#', data: 'index' },
            { title: 'Name', data: 'name' },
            { title: 'Email', data: 'email' },
            { title: 'Page Name', data: 'pageName' },
            { title: 'Visit Time', data: 'visitedDate' },
          ],
          responsive: true,
          autoWidth: false,
        };
      },
      (err) => {
        console.log(err);
      },
      () => {
        this.dataTable = $(this.table.nativeElement);
        this.dataTable.DataTable(this.dtOptions);
      }
    );
  }
}
